<template>
  <div class="news">
    <banner title="新闻资讯" subtitle="NEWS & INSIGHTS" />
    <div class="news-section" v-loading="loading">
      <div class="container">
        <div class="news-tabs">
          <div
            class="tab-item"
            :class="{ 'is-active': newstype === 3 }"
            @click="switchTab(3)"
          >
            <span>通知公告</span>
          </div>
          <div
            class="tab-item"
            :class="{ 'is-active': newstype === 1 }"
            @click="switchTab(1)"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="tab-item"
            :class="{ 'is-active': newstype === 2 }"
            @click="switchTab(2)"
          >
            <span>行业动态</span>
          </div>
        </div>

        <div class="news-list">
          <router-link
            v-for="(item, index) in newsList"
            :key="index"
            class="news-item"
            :to="{ name: 'newsdetails', params: { id: item.Id } }"
          >
            <h3 class="news-title">{{ item.Title }}</h3>
            <p v-if="formatSummary(item.Content)" class="news-summary">
              {{ formatSummary(item.Content) }}
            </p>
            <div class="news-meta">
              <span class="news-date">{{ formatDate(item.CreateTime) }}</span>
            </div>
          </router-link>
          <div v-if="!loading && !newsList.length" class="empty-tip">暂无相关资讯</div>
        </div>

        <el-pagination
          v-if="newsTotal > newsPageSize"
          class="news-pager"
          layout="prev, pager, next, jumper, total"
          :page-size="newsPageSize"
          :current-page.sync="newsPage"
          :total="newsTotal"
          background
        />
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: { Banner },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      newsPage: 1,
      newsPageSize: 10,
      newsTotal: 0
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/Page?type=${this.newstype}&page=${this.newsPage}&size=${this.newsPageSize}`)
        .then(response => {
          const data = response.data || {};
          this.newsList = data.Items || data.items || [];
          this.newsTotal = data.Total || data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.newsList = [];
          this.newsTotal = 0;
          this.loading = false;
        });
    },
    switchTab(type) {
      if (this.newstype === type) return;
      this.newstype = type;
      this.newsPage = 1; // 切换 tab 时回到第一页
      // 同步到 URL,刷新/分享/浏览器后退都能保持当前 tab
      this.$router.replace({ query: { ...this.$route.query, type } });
    },
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    },
    formatSummary(value) {
      if (!value) return "";
      // 富文本 → 纯文本:浏览器解码 HTML 实体(&nbsp; &amp; &lt; 等),再合并空白
      // 注意 &nbsp; 解码后是 U+00A0 不间断空格,JS 的 \s 不匹配,需显式列出
      const tmp = document.createElement("div");
      tmp.innerHTML = value;
      const text = (tmp.textContent || "")
        .replace(/[\s\u00A0\u3000]+/g, " ")
        .trim();
      if (!text) return "";
      return text.length > 110 ? text.slice(0, 110) + "…" : text;
    }
  },
  mounted() {
    // 从首页 ?type=3/?type=1/?type=2 跳过来时,自动选中对应 tab
    const t = parseInt(this.$route.query.type, 10);
    if ([1, 2, 3].includes(t)) {
      this.newstype = t;
    }
    this.loadData();
  },
  watch: {
    newstype() {
      this.loadData();
    },
    newsPage() {
      this.loadData();
    },
    // 地址栏改 URL(浏览器后退/手输 ?type=)时,同步切换 tab
    "$route.query.type"(val) {
      const t = parseInt(val, 10);
      if ([1, 2, 3].includes(t) && this.newstype !== t) {
        this.newstype = t;
        this.newsPage = 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.news {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.news-section {
  padding: 28px 0 0;
}

.news-section > .container {
  background: #fff;
  border: 1px solid $color-border;
}

.news-tabs {
  display: flex;
  border-bottom: 2px solid $color-border;
  background: $color-bg-2;

  .tab-item {
    padding: 14px 32px;
    font-size: 15px;
    color: $color-text-2;
    cursor: pointer;
    border-right: 1px solid $color-border;
    background: #fff;
    position: relative;
    transition: color 0.2s ease;

    &:hover { color: $color-accent; }
  }

  .is-active {
    color: $color-accent;
    background: #fff;
    font-weight: 600;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: -2px;
      height: 3px;
      background: $color-accent;
    }
  }
}

.news-list {
  padding: 8px 24px 24px;
}

// 列表项改成"标题 + 摘要 + 元信息"三段式
.news-item {
  display: flex;
  flex-direction: column;
  padding: 22px 4px;
  border-bottom: 1px solid $color-border;
  color: $color-text;
  transition: background 0.2s ease;

  &:last-child { border-bottom: none; }
  &:hover {
    .news-title { color: $color-accent; }
  }

  .news-title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: $color-text;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s ease;
  }

  .news-summary {
    margin: 10px 0 0;
    font-size: 13px;
    line-height: 1.7;
    color: $color-text-2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-meta {
    margin-top: 12px;
    display: flex;
    align-items: center;
  }

  .news-date {
    font-size: 12px;
    color: $color-text-3;
  }
}

.empty-tip {
  padding: 60px 0;
  text-align: center;
  color: $color-text-3;
}

.news-pager {
  padding: 16px 24px 24px;
  text-align: center;
}

@media (max-width: 720px) {
  .news-tabs .tab-item { padding: 12px 18px; font-size: 14px; }
  .news-item { padding: 12px 0; }
  .news-date { font-size: 12px; }
}
</style>
